import Resizer from 'react-image-file-resizer';
import { ResizeImage } from './types';

export const resizeImage = (file: File, config?: ResizeImage.Config): Promise<File> => {
  const IMG_CONFIGS = config || [1000, 1000, 90, 'JPEG'];

  return new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      IMG_CONFIGS[0], // max width
      IMG_CONFIGS[1], // max height
      IMG_CONFIGS[3], // format
      IMG_CONFIGS[2], // compression quality for JPEG
      0,
      async (uri: File) => {
        resolve(uri);
      },
      'file'
    );
  });
};
